import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);

export default {
    data() {
        return {
            files: [],
            category: '',
            language: '',
            title: '',
            explain: '',
            type: '',

            imageFile: [],
            content: '',
            sequence: '',

            premium: '',
            videoFile: [],
            subTitle:'',
            bookFile:[],
            bookList: [],
            sIdx : []
        }
    },
    validators: {
        files: function (value) {
            return Validator.value(value)
                .required('이미지를 선택해주세요.')
        },
        category: function(value) {
            return Validator.value(value)
                .required('카테고리를 선택해주세요.')
        },
        language: function(value) {
            return Validator.value(value)
        },
        title: function (value) {
            return Validator.value(value)
                .required('제목을 입력해 주세요.')
        },
        explain: function (value) {
            return Validator.value(value)
                .required('설명 문구를 입력해주세요.')
        },
        type: function (value) {
            return Validator.value(value)
                .required('콘텐츠 타입을 설정해주세요.')
        },

        imageFile: function (value) {
            return Validator.value(value)
                .required('이미지를 선택해주세요.')
        },
        content: function (value) {
            return Validator.value(value)
                .required('내용을 입력해주세요.')
        },
        sequence: function (value) {
            return Validator.value(value)
                .integer('1이상의 숫자만 입력이 가능합니다.')
                .greaterThanOrEqualTo(1, '1이상의 숫자만 입력이 가능합니다.')
        },

        premium: function (value) {
            return Validator.value(value)
                .required('프리미엄 여부를 설정해주세요.')
        },
        videoFile: function (value) {
            return Validator.value(value)
                .required('이미지를 선택해주세요.')
        },
        subTitle: function (value) {
            return Validator.value(value)
        },
        sIdx: function (value) {
            return Validator.value(value)
        },
    },
}
